import React from "react";
import { Button, Space } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { FaWhatsapp } from "react-icons/fa";

export const LeadsColumns = (
  onPickLead,
  pickedLeadIds = new Set(),
  loadingLeadIds = new Set(),
  pickedByMap = {},  // { leadId: userName }
  onOpenWhatsapp,
  whatsappLoadingLeadIds = new Set(),
  currentUserId, // <-- new
  onEditLead // <-- new: called with the record when Edit is clicked
) => {
  return [
    { title: "Id", dataIndex: "id", sorter: true, width: 80 },
    { title: "Full Name", dataIndex: "fullName", sorter: true },
    { title: "Service Required", dataIndex: "serviceRequired", sorter: true },
    { title: "Nationality", dataIndex: "nationality" },
    { title: "Phone", dataIndex: "phoneNumber" },
    { title: "Email", dataIndex: "email" },
    { title: "Preferred Country", dataIndex: "preferredCountry" },
    {
      title: "Picked By",
      dataIndex: "pickedBy",
      render: (value, record) => pickedByMap[record.id] ?? value,
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => {
        const pickedLocally = pickedLeadIds.has(record.id);
        const pickedOnServer =
          record.pickedBy != null && record.pickedBy.toLowerCase() !== "admin";
        const isPicked = pickedLocally || pickedOnServer;
        const isLoading = loadingLeadIds.has(record.id);
        const isWhatsappLoading = whatsappLoadingLeadIds.has(record.id);

        // Only show the WhatsApp icon if this lead was picked, AND
        // picked specifically by the currently logged-in user.
        const canOpenWhatsapp =
          record.pickedById != null &&
          Number(record.pickedById) === Number(currentUserId);

        return (
          <Space size={8} align="center">
            <Button
              type={isPicked ? "default" : "primary"}
              disabled={isPicked || isLoading}
              loading={isLoading}
              onClick={() => onPickLead(record.id)}
              style={{ height: 32, display: "flex", alignItems: "center" }}
            >
              {isPicked ? "Picked" : "Pick Lead"}
            </Button>

            {canOpenWhatsapp && (
              <Button
                type="text"
                shape="circle"
                onClick={() => onEditLead?.(record)}
                title="Edit lead"
                style={{
                  height: 32,
                  width: 32,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: 0,
                }}
              >
                <EditOutlined style={{ fontSize: 18, color: "#1677ff" }} />
              </Button>
            )}

            {canOpenWhatsapp && (
              <Button
                type="text"
                shape="circle"
                loading={isWhatsappLoading}
                disabled={isWhatsappLoading}
                onClick={() => onOpenWhatsapp?.(record)}
                title="Chat on WhatsApp"
                style={{
                  height: 32,
                  width: 32,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: 0,
                }}
              >
                {!isWhatsappLoading && <FaWhatsapp size={20} color="#25D366" />}
              </Button>
            )}
          </Space>
        );
      },
    },
  ];
};

export const LeadsFilters = [
  { label: "All", filterParam: "all", value: null },
  { label: "Today", filterParam: "today", value: "true" },
  { label: "Yesterday", filterParam: "yesterday", value: "true" },
  { label: "Untouched", filterParam: "untouched", value: "true" },
];